import react, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import TestForm from './TestForm'
import TestList from './TestList'

function Main() {
  const params = useParams()

  const [testId, setTestId] = useState<number>(0)
  useEffect(() => {
    if (params.id) {
      setTestId(parseInt(params.id))
    } else {
      setTestId(0)
    }
  }, [params.id])

  return testId === 0 ? <TestList /> : <TestForm testId={testId} />
}

export default Main
